<template>
  <div class="locations text-center py-3">
    <template v-if="clinics.length < 1">
      <v-toolbar color="#E21A22" dark>
        <v-text-field v-model="search" append-icon="mdi-magnify" label="Search" single-line hide-details></v-text-field>
      </v-toolbar>
      <v-row>
        <v-col>
          <v-data-table :headers="headers" :items="locations" :items-per-page="10" :search="search" class="elevation-1">
            <template v-slot:item.adminAccess="{ item }">
              <template v-if="item.adminAccess == 1">
                <v-btn icon color="red" @click="adminAccessFn(item)">
                  <v-icon>mdi-account-multiple-plus</v-icon>
                </v-btn>
              </template>
            </template>
          </v-data-table>
        </v-col>
      </v-row>
    </template>
    <template v-else>
      <div>
        <v-card class="mx-auto" max-width="800">
          <v-container>
            <v-row>
              <v-col cols="12" md="6">
                <v-text-field v-model="clinicUsername" label="Clinic Username"></v-text-field>
              </v-col>
              <v-col cols="12" md="6">
                <v-text-field v-model="clinicPassword" label="Clinic Password"
                  :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'" :type="show1 ? 'text' : 'password'"
                  @click:append="show1 = !show1"
                  hint="Leave it empty if you don't want to change the password"></v-text-field>
              </v-col>
            </v-row>
          </v-container>
          <v-list flat subheader one-line>
            <v-subheader>Please check the clinics which this user has access</v-subheader>

            <v-list-item-group multiple active-class="">
              <v-list-item v-for="cl in clinics" :key="cl.value">
                <template>
                  <v-list-item-action>
                    <v-checkbox v-model="cl.active"></v-checkbox>
                  </v-list-item-action>

                  <v-list-item-content>
                    <v-list-item-title v-text="cl.title"></v-list-item-title>
                  </v-list-item-content>
                </template>
              </v-list-item>
            </v-list-item-group>
          </v-list>
        </v-card>
        <br />
        <v-btn @click="clinics = []" color="secondary">CANCEL</v-btn>&nbsp;
        <v-btn @click="saveClinics" color="primary">SAVE</v-btn>
      </div>
    </template>
  </div>
</template>
<script>
export default {
  name: "Locations",
  data: () => ({
    locations: [],
    clinics: [],
    selectedClinic: "",
    clinicUsername: "",
    clinicPassword: "",
    show1: false,
    headers: [
      { text: "Location", value: "serviceAddress" },
      { text: "City", value: "city" },
      { text: "Zip Code", value: "zipCode" },
      { text: "Phone Number", value: "phoneNumber" },
      { text: "E-mail", value: "email" },
      { text: "Admin Access", value: "adminAccess" }
    ],
    search: ""
  }),
  computed: {},
  methods: {
    getLocations: function () {
      var este = this;
      este.$http
        .post(este.$api + "locations", {
          customer_id: este.$store.getters.customer_id,
          token: este.$store.getters.token,
        })
        .then(function (response) {
          if (response.status == 200 && response.data.status == "ok") {
            console.log("IMPRIME DATOS");
            window.console.log(response.status);
            este.locations = response.data.data;
          } else {
            var mensaje = {
              color: "red",
              timeout: 5000,
              message: response.data.msg
            };
            este.locations = [];
            este.$store.commit("msgMuestra", mensaje);
            if ("error" in response.data && response.data.error == "logout") {
              este.$router.push("/logout");
            }
          }
        })
        .catch(function (err) {
          este.locations = [];
          var mensaje = {
            color: "red",
            timeout: 5000,
            message: "There was an error. Please try again."
          };
          este.$store.commit("msgMuestra", mensaje);
          window.console.log(err);
        });
    },
    adminAccessFn: function (item) {
      var este = this;
      este.selectedClinic = item.id;
      este.$http
        .post(este.$api + "adminAccess", {
          customer_id: este.$store.getters.customer_id,
          token: este.$store.getters.token,
          location_id: item.id
        })
        .then(function (response) {
          if (response.status == 200 && response.data.status == "ok") {
            este.clinics = response.data.clinics;
            este.clinicUsername = response.data.username;
            console.log(este.clinics);
          } else {
            let mensaje = {
              color: "red",
              timeout: 5000,
              message: response.data.msg
            };
            este.$store.commit("msgMuestra", mensaje);
            if ("error" in response.data && response.data.error == "logout") {
              este.$router.push("/logout");
            }
          }
        })
        .catch(function (err) {
          var mensaje = {
            color: "red",
            timeout: 5000,
            message: "There was an error. Please try again."
          };
          este.$store.commit("msgMuestra", mensaje);
          window.console.log(err);
        });
    },
    saveClinics: function () {
      var este = this;
      este.$http
        .post(este.$api + "saveClinics", {
          customer_id: este.$store.getters.customer_id,
          token: este.$store.getters.token,
          clinics: este.clinics,
          username: este.clinicUsername,
          password: este.clinicPassword,
          location_id: este.selectedClinic
        })
        .then(function (response) {
          if (response.status == 200 && response.data.status == "ok") {
            let mensaje = {
              color: "green",
              timeout: 5000,
              message: response.data.msg
            };
            este.$store.commit("msgMuestra", mensaje);
            este.clinics = [];
            este.selectedClinic = "";
            este.clinicUsername = "";
            este.clinicPassword = "";
          } else {
            let mensaje = {
              color: "red",
              timeout: 5000,
              message: response.data.msg
            };
            este.$store.commit("msgMuestra", mensaje);
            if ("error" in response.data && response.data.error == "logout") {
              este.$router.push("/logout");
            }
          }
        })
        .catch(function (err) {
          let mensaje = {
            color: "red",
            timeout: 5000,
            message: "There was an error. Please try again."
          };
          este.$store.commit("msgMuestra", mensaje);
          window.console.log(err);
        });
    }
  },
  watch: {
  },
  mounted: function () {
    this.$store.commit("title", "Pick Up Locations");
    if (!this.$store.getters.is_parent) {
      this.headers.pop();
    }
    this.getLocations();
  }
};
</script>
